
import {
  Switch,
  Button,
  Icon,
  Checkbox,
  Chip,
  FormControlLabel,
  Link,
  Tooltip,
  Typography,
  PropTypes,
  IconButton,
  ListItemIcon,
  TextField,
  MenuItem,
  Grid,
  Popover,
  List,
  ListItem,
  ListItemText,
  Divider,
  Card,
  CardContent,
  InputLabel,
  Select,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Backdrop,
  CircularProgress,
  Alert,
  AlertTitle,
} from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { SoketContext } from "src/Context_api";
import { GetSysConfigMaintenance } from "src/utils/GetAdmin";
import { useLocalStorage } from "src/utils/LocalStorageHook";

import { saveSysConfig } from "src/utils/PostAdmin";

export default function AdminAccessMode() {
  const {uuid}:any = useContext(SoketContext);

  const [checked, setChecked] = useState(false);
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [showLoader, setShowLoader] = useState(false);
  const [status, setStatus] = useState(false);
  const [statusMessage, setStatusmessage] = useState('');


  useEffect(() => {
    GetSysConfigMaintenance(salesOrg, { vp: true, vs: true }).then(
      (response: any) => {
        if (response) {
          if (response.param_value === 'true') {
            setChecked(true);
          }
          else {
            setChecked(false);
          }
        }



      })

  }, [])


  const handleMaintanence = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    setShowLoader(true)
    let param_value = event.target.checked ? 'true' : 'false'
    saveSysConfig(salesOrg, { vp: true, vs: true }, { param_name: 'maintenance_mode', param_value: param_value }).then(
      (response: any) => {
        setShowLoader(false);
        if (response.status) {
          if (param_value === 'true') {
            setStatusmessage('Maintenance mode has been successfully activated.')
            setStatus(true)
          }else{
            setStatusmessage('Maintenance mode has been successfully Deactivated.')
            setStatus(true)
          }

        } else {
          setStatusmessage(' Maintenance mode has been faild.')
          setStatus(true)
        }

      }).catch(err => {
        console.log('Errror', err);
        setShowLoader(false)
      })
  };


  return (
    <>
      <label>
        <Switch
          checked={checked}
          onChange={(e) => handleMaintanence(e)}
          inputProps={{ 'aria-label': 'controlled' }}
        />
        Maintenance Enabled </label>
      <Dialog open={status} onClose={() => setStatus(false)}>
        <DialogTitle>Maintenance </DialogTitle>
        <DialogContent>
          <DialogContentText><h4> {statusMessage} </h4></DialogContentText>
        </DialogContent>

      </Dialog>
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={showLoader}>
        <CircularProgress color="primary" />
      </Backdrop>
    </>

  )
}